import classNames from "classnames"

import { ContentTag, provideComponent } from "scrivito"

import { CardWidget } from "./CardWidgetClass"

provideComponent(CardWidget, ({ widget }) => {
  const maxWidth = widget.get("maxWidth")
  const alignment = widget.get("alignment")
  const outerPaddingX = widget.get("outerPaddingX")
  const outerPaddingY = widget.get("outerPaddingY")
  const innerPaddingX = widget.get("innerPaddingX")
  const innerPaddingY = widget.get("innerPaddingY")
  const elevated = widget.get("elevated")

  return (
    <div
      className={classNames([
        "card-widget",
        alignment,
        outerPaddingX,
        outerPaddingY
      ])}
      style={typeof maxWidth === "number" ? { maxWidth: `${maxWidth}px` } : {}}
    >
      <ContentTag
        className={classNames([
          "card",
          innerPaddingX,
          innerPaddingY,
          { "card--elevated": elevated }
        ])}
        content={widget}
        attribute="content"
      />
    </div>
  )
})
